import type { RouteRecordRaw } from 'vue-router'

// Placeholder for the secondary-market BUY flow only — purchasing resale
// inventory listed by other investors. The sell-side flow lives in the
// sibling marketplace/sell/. The marketplace/browse/ surface owns discovery.
export const marketplaceInvestRoutes: RouteRecordRaw[] = []
